module.exports = function (lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && clickTimestamp - lastTouchEvent < 750) {
    return true;
  }
};